import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const StrategicPartners = () => {
  const [visibleCols, setVisibleCols] = useState([]);
  const [resetting, setResetting] = useState(false);

  const partners = [
    { name: 'DELL', logo: '/Strategicpartners/DELL.png' },
    { name: 'HP', logo: '/Strategicpartners/HP.png' },
    { name: 'Lenovo', logo: '/Strategicpartners/Lenovo.svg' },
    { name: 'Intel', logo: '/Strategicpartners/Intel.png' },
    { name: 'D-Link', logo: '/Strategicpartners/D-Link.png' },
    { name: 'Microsoft', logo: '/Strategicpartners/Microsoft.png' },
    { name: 'IBM', logo: '/Strategicpartners/IBM.png' },
    { name: 'CISCO', logo: '/Strategicpartners/CISCO.png' },
    { name: 'EPSON', logo: '/Strategicpartners/EPSON.png' },
    { name: 'Canon', logo: '/Strategicpartners/Canon.png' },
    { name: 'VMware', logo: '/Strategicpartners/vmware.svg' },
    { name: 'Quick Heal', logo: '/Strategicpartners/QuickHeal.svg' },
  ];

  // Group into vertical pairs (columns)
  const columns = [];
  for (let i = 0; i < partners.length; i += 2) {
    columns.push([partners[i], partners[i + 1]]);
  }

  const [currentCol, setCurrentCol] = useState(0);

  useEffect(() => {
    if (resetting) return;

    const interval = setInterval(() => {
      if (currentCol < columns.length) {
        setVisibleCols((prev) => [...prev, currentCol]);
        setCurrentCol((prev) => prev + 1);
      } else {
        setTimeout(() => {
          setResetting(true);
          setVisibleCols([]);
          setCurrentCol(0);
          setTimeout(() => setResetting(false), 800); // wait before restarting
        }, 2000);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [currentCol, columns.length, resetting]);

  return (
    <section className="bg-white py-16 px-6 md:px-12 lg:px-20 min-h-screen overflow-x-hidden" style={{ backgroundImage: `url('/Strategicpartners/Strategic-bg.png')` }}>
      <h2 className="text-5xl font-bold text-center text-white mb-10">
        Our <span className="text-7xl text-sky-400">Strategic Partners</span>
      </h2>

      <p className="text-2xl text-white max-w-10xl mb-14 text-left">
        We collaborate with globally recognized technology leaders to deliver innovative, secure, and scalable solutions to our clients.
        These partnerships empower us to stay ahead in the fast-paced digital world and serve you better.
      </p>

      <div className="flex gap-6 items-start justify-center flex-wrap">
        {columns.map((col, colIndex) => (
          <AnimatePresence key={colIndex}>
            {visibleCols.includes(colIndex) && (
              <motion.div
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
                className="flex flex-col gap-6"
              >
                {col.map((partner, i) => (
                  <div
                    key={partner.name}
                    className="flex justify-center items-center h-28 w-40 p-4 bg-gray-300 rounded-xl shadow-md hover:shadow-lg"
                  >
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="max-h-20 w-auto object-contain"
                    />
                  </div>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        ))}
      </div>
    </section>
  );
};

export default StrategicPartners;
